import {Agent, SplitMethodType, ViewBase} from '@ozark/common';
import {Column} from '@ozark/common/api/Column';
import {format} from 'date-fns';
import {utcToZonedTime} from 'date-fns-tz';

type ColumnWithGroupAdminFilter = Column<ViewBase<Agent>> & {forGroupAdminOnly?: boolean};

export const columnsConfig: ColumnWithGroupAdminFilter[] = [
  {
    id: 'createdAt',
    label: 'Created At',
    width: 160,
    sortable: true,
    selector: row => (row.createdAt ? format(row.createdAt.toDate(), 'MM/dd/yyyy h:mm a') : ''),
    export: row =>
      row.createdAt
        ? format(utcToZonedTime(new Date(row.createdAt.toDate()), 'UTC'), 'MM dd yyyy h:mm a')
        : '',
  },
  {
    id: 'firstName',
    label: 'First Name',
    width: 160,
    export: true,
    sortable: true,
  },
  {
    id: 'lastName',
    label: 'Last Name',
    width: 160,
    export: true,
    sortable: true,
  },
  {
    id: 'email',
    label: 'Email',
    export: true,
    width: 200,
  },
  {
    id: 'phone',
    label: 'Phone',
    export: true,
  },
  {
    id: 'role',
    label: 'Role',
    export: true,
  },
  {
    id: 'masterName',
    label: 'Master Agent',
    sortable: true,
    export: true,
    forGroupAdminOnly: true,
  },
  {
    id: 'agentCode',
    label: 'Agent Code',
    sortable: true,
    selector: row => row.agentCode ?? 'N/A',
    export: row => row.agentCode ?? 'N/A',
    forGroupAdminOnly: true,
  },
  {
    id: 'subAgentCode',
    label: 'Sub Agent Code',
    sortable: true,
    selector: row => row.subAgentCode ?? '',
    export: row => (row.subAgentCode ? `${row.agentCode}-${row.subAgentCode}` : ''),
    forGroupAdminOnly: true,
  },
  {
    id: 'lastLoginAt',
    label: 'Last Login',
    selector: row => (row.lastLoginAt ? format(row.lastLoginAt.toDate(), 'MM/dd/yyyy h:mm a') : ''),
    export: row => (row.lastLoginAt ? format(row.lastLoginAt.toDate(), 'MM/dd/yyyy h:mm a') : ''),
  },
  {
    id: 'payBy',
    label: 'Pay By',
    sortable: true,
    export: row => row.payBy || '',
  },
  {
    id: 'permissions.residuals',
    label: 'Residual Access',
    sortable: true,
    selector: row => (row.permissions?.residuals === true ? 'Yes' : 'No'),
    export: row => (row.permissions?.residuals === true ? 'Yes' : 'No'),
  },
  {
    id: 'latestScheduleAVersion.splitMethod',
    label: 'Calculation Method',
    sortable: true,
    selector: row =>
      row.latestScheduleAVersion?.splitMethod &&
      row.latestScheduleAVersion.splitMethod === SplitMethodType.direct
        ? 'Direct Calculation'
        : 'Split of Split',
    export: row =>
      row.latestScheduleAVersion?.splitMethod &&
      row.latestScheduleAVersion.splitMethod === SplitMethodType.direct
        ? 'Direct Calculation'
        : 'Split of Split',
  },
  {
    id: 'latestScheduleAVersion.splitNegativeResiduals',
    label: 'Split Negative Residuals',
    sortable: true,
    selector: row => (row.latestScheduleAVersion?.splitNegativeResiduals ? 'Yes' : 'No'),
    export: row => (row.latestScheduleAVersion?.splitNegativeResiduals ? 'Yes' : 'No'),
  },
  {
    id: 'isScheduleAVisible',
    label: 'Hide Schedule A',
    selector: row => (row.isScheduleAVisible === true ? 'No' : 'Yes'),
    export: row => (row.isScheduleAVisible === true ? 'No' : 'Yes'),
    sortable: true,
  },
  {
    id: 'updatedAt',
    label: 'Last Updated Date',
    selector: row => (row.updatedAt ? format(row.updatedAt.toDate(), 'MM/dd/yyyy h:mm a') : ''),
    export: row =>
      row.updatedAt
        ? format(utcToZonedTime(new Date(row.updatedAt.toDate()), 'UTC'), 'MM dd yyyy h:mm a')
        : '',
    sortable: true,
  },
];
